import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    transporteId: 0,
    transporte: {},
    transporteNombre: null,
    comprobanteTipoId: 0,
    comprobanteTipo: {},
    comprobanteTipoNombre: null,
    formulario: '',
    numeroPuntoVenta: 0,
    numero: 0,
    total: 0,
    observaciones: '',
    renglones: [],
    rowVersion: null,

    /* Validaciones */
    comprobanteTipoValido: null,
    comprobanteTipoInvalidoMsj: '',
    formularioValido: null,
    formularioInvalidoMsj: '',

    formularios: [],
    formularioDisabled: false,
    numeroPuntoVentaDisabled: false,
    numeroDisabled: false,
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDEN' (state, ordenFacturacionLogisticaId) {
        state.id = ordenFacturacionLogisticaId;
        state.fechaComprobante = moment.utc(new Date()).format('YYYY-MM-DD');
        state.transporteId= 0;
        state.transporte= null;
        state.transporteNombre= null;
        state.comprobanteTipoId = 0;
        state.comprobanteTipo = null;
        state.comprobanteTipoNombre = null;
        state.formulario = '';
        state.numeroPuntoVenta = 0;
        state.numero = 0;
        state.total = 0;
        state.observaciones = '';
        state.renglones = [];
        state.rowVersion = null;
        
        /* Validaciones */
        state.comprobanteTipoValido = null;
        state.comprobanteTipoInvalidoMsj = '';
        state.formularioValido = null;
        state.formularioInvalidoMsj = '';

        state.formularios = ['A', 'B', 'C', 'X'];
        state.formularioDisabled = false;
        state.numeroPuntoVentaDisabled = false;
        state.numeroDisabled = false;
    },
    'SET_ORDEN' (state, ordenFacturacionLogistica) {
        state.fechaComprobante = moment(ordenFacturacionLogistica.fechaComprobante).format('YYYY-MM-DD'),
        state.transporteId = ordenFacturacionLogistica.transporte? ordenFacturacionLogistica.transporte.id : 0;
        state.transporte = ordenFacturacionLogistica.transporte;
        state.transporteNombre = ordenFacturacionLogistica.transporte? ordenFacturacionLogistica.transporte.nombre.trim() : null;
        state.comprobanteTipoId = ordenFacturacionLogistica.comprobanteTipo ? ordenFacturacionLogistica.comprobanteTipo.id : 0;
        state.comprobanteTipo = ordenFacturacionLogistica.comprobanteTipo;
        state.comprobanteTipoNombre = ordenFacturacionLogistica.comprobanteTipo ? ordenFacturacionLogistica.comprobanteTipo.nombre.trim() : null;
        state.formulario = ordenFacturacionLogistica.formulario;
        state.numeroPuntoVenta = ordenFacturacionLogistica.numeroPuntoVenta;
        state.numero = ordenFacturacionLogistica.numero;
        state.observaciones = ordenFacturacionLogistica.observaciones;
        state.rowVersion = ordenFacturacionLogistica.rowVersion;
        state.renglones = ordenFacturacionLogistica.renglones;

        state.total= state.renglones
            .reduce((importe, renglon) => importe + renglon.importe, 0);

        state.formularioDisabled = false;
        state.numeroPuntoVentaDisabled = false;
        state.numeroDisabled = false;
        switch (state.comprobanteTipoId) {
            case 9:
                state.formularioDisabled = true;
                state.numeroPuntoVentaDisabled = true;
                state.numeroDisabled = false;
                break;
        }
    },
    'SET_TRANSPORTE'(state, transporte) {
        state.transporte = transporte;
        state.transporteId = transporte? transporte.id : 0;
        state.transporteNombre = transporte? transporte.nombre.trim() : null;
    },
    'SET_COMPROBANTE_TIPO'(state, comprobanteTipo) {
        state.comprobanteTipoId = comprobanteTipo ? comprobanteTipo.id : 0;
        state.comprobanteTipo = comprobanteTipo;
        state.comprobanteTipoNombre = comprobanteTipo ? comprobanteTipo.nombre.trim() : null;

        /* Verificar formularios disponibles */
        switch (state.comprobanteTipoId) {
            case 9:
                state.numeroPuntoVenta = 1;
                state.numero = 0;
                state.formulario = 'X';
                state.formularioDisabled = true;
                state.numeroPuntoVentaDisabled = true;
                state.numeroDisabled = false;
                break;

            default:
                state.numeroPuntoVenta = 0;
                state.numero = 0;
                state.formulario = '';
                state.formularioDisabled = false;
                state.numeroPuntoVentaDisabled = false;
                state.numeroDisabled = false;
                break;
        }
    },
    'SET_REMITOS' (state, remitos) {
        state.renglones = [];
        state.total = 0;

        remitos.map(remito => {
            // state.renglones.push({ ...remito, importe: 0, _rowVariant: ''});

            let renglon = {
                remitoId: remito.id,
                presupuestoInternoId: remito.presupuestoInternoId,
                presupuestoInterno: [],
                fechaComprobante: remito.fechaComprobante,
                comprobante: remito.comprobante,
                destino: remito.remitoDestino,
                importe: 0,
                _rowVariant: '',
                _showDetails: remito.presupuestoInternoId != 0,
            }

            renglon.presupuestoInterno.push({
                presupuestoInterno: remito.presupuestoInternoId != 0 ? '(' + remito.presupuestoInternoId.toString().trim() + ') ' + remito.presupuestoInterno.trim() : '',
                ordenTrabajo: remito.ordenTrabajoId != 0 ? '(' + remito.ordenTrabajoId.toString().trim() + ') ' + remito.ordenTrabajo.trim() : '',
                subtrabajo: remito.ordenSubtrabajoId != 0 ? '(' + remito.ordenSubtrabajoId.toString().trim() + ') ' + remito.ordenSubtrabajo.trim() : '',
            });

            state.renglones.push(renglon);
        });
    },
    'CALCULAR_TOTAL' (state) {
        state.total= state.renglones
            .reduce((importe, renglon) => importe + parseFloat(renglon.importe), 0);
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, ordenFacturacionLogisticaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDEN', ordenFacturacionLogisticaId);

            if (ordenFacturacionLogisticaId != 0) {
                apiAxios.get('ordenesfacturacionlogistica/' + ordenFacturacionLogisticaId + '/abm' ) 
                    .then(res => {
                        commit('SET_ORDEN', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (parseFloat(state.total) == 0) {
                save = false;
                errorMessage = "El importe total de la orden no puede ser igual a cero."
            }

            if (save) {
                let renglones = [];
                if (state.renglones) {
                    state.renglones.forEach(renglon => {
                        if (parseFloat(renglon.importe) != 0) {
                            renglones.push({
                                remitoId: renglon.remitoId,
                                importe: parseFloat(renglon.importe)
                            });
                        }
                    });
                }

                let ordenFacturacionLogistica= {
                    fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                    transporteId: parseInt(state.transporteId),
                    comprobanteTipoId: parseInt(state.comprobanteTipoId),
                    formulario: state.formulario.toUpperCase().trim(),
                    numeroPuntoVenta: parseInt(state.numeroPuntoVenta),
                    numero: parseInt(state.numero),
                    observaciones: state.observaciones.trim(),
                    renglones: renglones
                };

                let url = 'ordenesfacturacionlogistica';
                if (state.id != 0) {
                    url += '/' + state.id;
                    ordenFacturacionLogistica.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, ordenFacturacionLogistica)
                    .then(() => {
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

    setTransporte: ({ commit }, transporte) => {
        return new Promise((resolve, reject) => {
            commit('SET_TRANSPORTE', transporte);

            if (transporte) {
                apiAxios.get('remitos/facturar/' + transporte.id)
                    .then(res => {
                        commit('SET_REMITOS', res.data);

                        resolve();
                    })
                    .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }

        }, error => {
            reject(error);
        })
    },
    setComprobanteTipo: ({commit}, comprobanteTipo) => {
        commit('SET_COMPROBANTE_TIPO', comprobanteTipo);
    },
    calcularTotal: ({ commit }) => {
        commit('CALCULAR_TOTAL');
    },
};

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
        sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
} 

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}